import React from 'react';
import { CALIFORNIA_REGIONS } from '../services/regionMapping';

interface RegionSelectorProps {
  selectedRegion: number;
  onRegionChange: (regionId: number) => void;
  disabled?: boolean;
  availableRegions?: number[]; // Optional: filter which region IDs to show
}

const RegionSelector: React.FC<RegionSelectorProps> = ({ 
  selectedRegion, 
  onRegionChange, 
  disabled = false,
  availableRegions 
}) => {
  // Filter regions if availableRegions prop is provided
  const regionsToShow = availableRegions 
    ? CALIFORNIA_REGIONS.filter(region => availableRegions.includes(region.id))
    : CALIFORNIA_REGIONS;
  
  // If filtering, don't show "All California" option
  const showAllCalifornia = !availableRegions;

  return (
    <div className="region-selector">
      <label htmlFor="region-select" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '16px' }}>
        Select Region:
      </label>
      <select
        id="region-select"
        value={selectedRegion}
        onChange={(e) => onRegionChange(parseInt(e.target.value))}
        disabled={disabled}
        style={{
          width: '100%',
          maxWidth: '400px',
          padding: '10px',
          fontSize: '14px',
          borderRadius: '6px',
          cursor: disabled ? 'not-allowed' : 'pointer'
        }}
        className="region-selector-select"
      >
        {showAllCalifornia && <option value={0}>All California</option>}
        {regionsToShow.map((region) => (
          <option key={region.id} value={region.id}>
            {region.name}
          </option>
        ))}
      </select>
      <div className="region-selector-hint" style={{ marginTop: '8px', fontSize: '12px', fontStyle: 'italic' }}>
        Currently functional for San Francisco Bay Area. Other regions coming soon.
      </div>
    </div>
  );
};

export default RegionSelector;
